<template>
  <v-autocomplete
      v-model="input"
      :items="siteTypes"
      item-text="keyAlias"
      dense
      item-value="key"
      :rules="rules"
      :error-messages="errors !== undefined ? errors : []"
      label="نوع کیفیت سایت"
      outlined
      :return-object="return_object"
  ></v-autocomplete>
</template>

<script>

export default {
  props: ['value', 'errors','dense', 'return_object'],

  data() {
    return {
      input: this.value,
        rules:[
            (value) => !!value || "وارد کردن این فیلد الزامی است.",
        ],
      siteTypes: [
        {key:'high',keyAlias:'سایت حرفه ای با کیفیت بالا'},
        {key:'good',keyAlias:'کیفیت خوب و قابل قبول'},
        {key:'normal',keyAlias:'کیفیت عادی'},
        {key:'least',keyAlias:'حداقل موارد مورد نیاز فقط رعایت شود.'},
      ],

    }
  },
  name: "siteSelect",
  watch : {
    input(){
      this.$emit('input', this.input)
    }
  }
}
</script>

<style scoped>

</style>